import { TextButton } from "../../Buttons/TextButton"
import { MediaType } from "@jconradi/tutu-porn-api-client/src/media";
import useTranslation from "next-translate/useTranslation";
import cls from 'clsx';

export interface MediaTypeSelectorProps {
    mediaType?: MediaType;
    setMediaType: (val?: MediaType) => void;
}
export const MediaTypeSelector = ({ mediaType, setMediaType }: MediaTypeSelectorProps) => {
    const { t } = useTranslation('common');

    const common = "text-base sm:text-lg p-2 sm:px-[14px] sm:py-[17px] sm:min-w-[84px] text-center flex items-center justify-center";

    return (
        <>
            <div className="items-center justify-center flex-wrap grid grid-cols-4 sm:flex">
                <TextButton className={cls(common)} onClick={() => setMediaType(undefined)} active={mediaType === undefined} side={'left'}>
                    {/* <IconContainer responsiveText={false} icon={<MoneyIcon className="h-8 w-8 text-green-500" />} label="All" /> */}
                    {t('allMediaTypes')}
                </TextButton>

                <TextButton className={cls(common, "rounded-none")} onClick={() => setMediaType(MediaType.Video)} active={mediaType === 'video'} side={'middle'}>
                    {/* <IconContainer responsiveText={false} icon={<PublicIcon className="h-8 w-8 text-white" />} label="Videos" /> */}
                    {t('videos')}
                </TextButton>

                <TextButton className={cls(common, "rounded-none")} onClick={() => setMediaType(MediaType.Photo)} active={mediaType === 'photo'} side={'middle'}>
                    {/* <IconContainer responsiveText={false} icon={<PublicIcon className="h-8 w-8 text-white" />} label="Pics" /> */}
                    {t('images')}
                </TextButton>

                <TextButton className={cls(common)} onClick={() => setMediaType(MediaType.Gallery)} active={mediaType === 'gallery'} side={'right'}>
                    {/* <IconContainer responsiveText={false} icon={<PublicIcon className="h-8 w-8 text-white" />} label="Gallerys" /> */}
                    {t('gallerys')}
                </TextButton>
            </div>

        </>
    )
}